import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { translate } from 'react-i18next';
import AppIcon from '../AppIcon';
import ErrorMessage from '../Messages/ErrorMessage';

class LoadingError extends Component {

  constructor(props) {
    super(props);
    this.onCloseErrorModal = this.onCloseErrorModal.bind(this);
  }

  onCloseErrorModal() {
    window.location.href = '/ajanvaraus';
  }

  render() {
    if (!this.props.rootLoaded) {
      return null;
    }
    const { routingParams, show, t } = this.props;
    const { location } = routingParams;
    const { query } = location;
    let message = '';
    if (query.sso && query.code) {
      switch (query.code) {
        case 'signicatError':
          message = <strong>{t('bankLoginError')}</strong>;
          break;
        case 'platformError':
          message = <strong>{t('platformError')}</strong>;
          break;
        case 'USER_WITH_SOTU_NOT_FOUND':
          message = <strong>{t('loginFailedUserWithSotuNotFound')}</strong>;
          break;
        case 'MULTIPLE_USERS_WITH_SOTU':
          message = <strong>{t('loginFailedMultipleUsersWithSotu')}</strong>;
          break;
        case 'ORGANIZATION_DOES_NOT_ALLOW_CLIENT_WITHOUT_EMPLOYER':
          message = <strong>{t('loginFailedOrganizationDoesNotAllowClientWithoutEmployer')}</strong>;
          break;
        case 'USER_WITHOUT_CREDIT_CHECK':
          message = <strong>{t('loginFailedUserWithoutCreditCheck')}</strong>;
          break;
        case 'PATH_REQUIRES_EMPLOYER_BUT_NOT_FOUND':
          message = <strong>{t('loginFailedPathRequiresEmployerButNotFound')}</strong>;
          break;
        case 'USER_WITH_SOTU_NOT_FOUND_AND_FAKE_SOTU':
          message = <strong>{t('loginFailedAndRegisterProhibited')}</strong>;
          break;
        default:
          message = <strong>{t('loadingAppError')}</strong>;
          break;
      }
    } else if (query.sso) {
      message = <strong>{t('ssoLoginError')}</strong>;
    } else {
      message = <strong>{t('loadingAppError')}</strong>;
    }
    return (
      <Modal
        className="error generic-error"
        show={show}
        backdrop="static"
        keyboard={false}
      >
        <Button
          bsStyle="link"
          className="close-link basic-action-link"
          onClick={this.onCloseErrorModal}
        >
          <AppIcon iconName="CLOSE" containerClass="close-icon" />
        </Button>
        <ErrorMessage isVisible>
          {message}
        </ErrorMessage>
      </Modal>
    );
  }
}

LoadingError.propTypes = {
  routingParams: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  rootLoaded: PropTypes.bool,
  t: PropTypes.func.isRequired
};

LoadingError.defaultProps = {
  show: true,
  rootLoaded: false
};

export default translate(['common'], { wait: true })(LoadingError);



// WEBPACK FOOTER //
// ./src/components/LoadingError/LoadingError.jsx